import IconFA from '../../components/icon/icon';
import { motion } from 'framer-motion';

function HPAdvantage() {
    return (
        <section>
            <h2>Unsere Vorteile</h2>
            <div className='advantageContainer'>
                <motion.div 
                    className='advantageIconContainer'
                    initial={{ opacity: 0, x: -50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1 }}
                    viewport={{ once: true, amount: 0.2 }}
                >
                    <IconFA color='#15283B' iconName='gear' />
                    <h3>Erhöhte Produktivität</h3>
                    <p>Verwalten Sie mühelos Kunden und Aufgaben mit minimalistischem Design für mehr Produktivität und Konzentration. </p>
                </motion.div>
                <motion.div 
                    className='advantageIconContainer'
                    initial={{ opacity: 0, x: -50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1 }}
                    viewport={{ once: true, amount: 0.2 }}
                >
                    <IconFA color='#15283B' iconName='lightbulb' />
                    <h3>Erhöhte Produktivität</h3>
                    <p>Verwalten Sie mühelos Kunden und Aufgaben mit minimalistischem Design für mehr Produktivität und Konzentration. </p>
                </motion.div>
                <motion.div 
                    className='advantageIconContainer'
                    initial={{ opacity: 0, x: 50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1 }}
                    viewport={{ once: true, amount: 0.2 }}
                >
                    <IconFA color='#15283B' iconName='circleCheck' />
                    <h3>Erhöhte Produktivität</h3>
                    <p>Verwalten Sie mühelos Kunden und Aufgaben mit minimalistischem Design für mehr Produktivität und Konzentration. </p>
                </motion.div>
                <motion.div 
                    className='advantageIconContainer'
                    initial={{ opacity: 0, x: 50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1 }}
                    viewport={{ once: true, amount: 0.2 }}
                >
                    <IconFA color='#15283B' iconName='rocket' />
                    <h3>Erhöhte Produktivität</h3>
                    <p>Verwalten Sie mühelos Kunden und Aufgaben mit minimalistischem Design für mehr Produktivität und Konzentration. </p>
                </motion.div>
            </div>
        </section>
    );
}

export default HPAdvantage;